import * as yup from 'yup'
export const contactFormSchema = yup.object().shape({
  name :  yup.string().required('Enter valid name'),
  email : yup.string().required('Enter email').email('Enter valid email'),
  message : yup.string().required("Enter mesage")
})